import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { XMLParser } from 'fast-xml-parser';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header2 from './header2';
import Footer from './footer';

function FetchImage() {
    const { id, did } = useParams();
   
    const navigate = useNavigate();
    const [image, setImage] = useState(null);
    const [selectedSize, setSelectedSize] = useState(null);
    const [price, setPrice] = useState(null);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        instructions: '',
        did: did
    });

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    useEffect(() => {
        const fetchImageById = async () => {
            try {
                const response = await fetch(`${baseURL}/api/image-details/${id}?currency=INR`);
                const xmlText = await response.text();
                const parser = new XMLParser({ ignoreAttributes: false });
                const parsedData = parser.parse(xmlText);
                
                const imageNode = parsedData?.rsp?.image;

                if (imageNode) {
                    const imageDetails = {
                        id: imageNode['@_id'],
                        description: imageNode.description,
                        contributor: imageNode.contributor['@_id'],
                        filename: imageNode['@_filename'],
                        folder: imageNode['@_folder'],
                        src: `http://images.assetsdelivery.com/thumbnails/${imageNode.contributor['@_id']}/${imageNode['@_folder']}/${imageNode['@_filename']}.jpg`,
                        sizes: Array.isArray(imageNode.sizes.size)
                            ? imageNode.sizes.size.map(size => ({
                                label: size['@_label'],
                                width: size['@_width'],
                                height: size['@_height'],
                                price: size['@_price'],
                                format: size['@_format'],
                            }))
                            : [],
                    };

                    setImage(imageDetails);
                    if (imageDetails.sizes.length > 0) {
                        setSelectedSize(imageDetails.sizes[0].label);
                        setPrice(imageDetails.sizes[0].price);
                    }
                }
            } catch (error) {
                console.error('Error fetching image:', error);
            }
        };

        fetchImageById();
    }, [id, baseURL]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSizeChange = (e) => {
        const selectedLabel = e.target.value;
        setSelectedSize(selectedLabel);
        const selectedSizeObj = image.sizes.find(size => size.label === selectedLabel);
        setPrice(selectedSizeObj?.price || 0);
    };

    const handleGetQuote = async () => {
        try {
            const quoteData = {
                imageId: image.id,
                size: selectedSize,
                price: price,
                ...formData
            };

            const response = await fetch(`${baseURL}/api/submit-quote`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(quoteData)
            });

            const result = await response.json();
            if (response.ok) {
                toast.success('Submission successful! Redirecting in 3 seconds...', {
                    position: 'top-center',
                    autoClose: 3000
                });
                setTimeout(() => {
                    navigate(`/collection/${did}`);
                }, 3000);
            } else {
                toast.error(`Failed to submit quote: ${result.message}`, {
                    position: 'top-center'
                });
            }
        } catch (error) {
            console.error('Error submitting quote:', error);
            toast.error('An error occurred while submitting the quote.', {
                position: 'top-center'
            });
        }
    };

    if (!image) {
        return <div>Loading image...</div>;
    }

    return (
        <>
        <Header2 />
        <div className="container mt-5">
            <div className="row" style={{ justifyContent: 'center' }}>
                <div className="col-sm-5">
                    <img src={image.src} alt={image.description} className="img-fluid" style={{ width: '100%' }} />
                </div>
                <div className="col-sm-5" style={{ textAlign: 'left' }}>
                    <p style={{ textAlign: 'left', fontSize: '25px' }}><u>{image.description}</u></p>
                    <p style={{ fontSize: '18px' }}>Select Size</p>
                    <select className="form-select mb-3" value={selectedSize} onChange={handleSizeChange} style={{ width: '45%', marginTop: '-10px' }}>
                        {image.sizes.map((size, index) => (
                            <option key={index} value={size.label}>
                                {size.label} - {size.width}x{size.height} ({size.format})
                            </option>
                        ))}
                    </select>
                    <label>Credit Point:</label>
                    <p style={{ fontSize: '25px', fontWeight: 'bold' }}>{price}</p>
                    <label>Name:</label>
                    <input type="text" name="name" placeholder="Name" className="form-control mb-3" onChange={handleInputChange} />
                    <label>Email:</label>
                    <input type="email" name="email" placeholder="Email" className="form-control mb-3" onChange={handleInputChange} />
                    <label>Phone Number:</label>
                    <input type="text" name="phone" placeholder="Phone Number" className="form-control mb-3" onChange={handleInputChange} />
                    <label>Instructions:</label>
                    <textarea name="instructions" placeholder="Instructions" className="form-control mb-3" rows="3" onChange={handleInputChange}></textarea>
                    <button className='btn btn-primary' onClick={handleGetQuote}>Submit</button>
                </div>
            </div>
        </div>
        <Footer />
        <ToastContainer />
        </>
    );
}

export default FetchImage;
